import React from 'react';
import classNames from 'classnames';
import { Observe } from 'rewire-core';
import { WithStyle, withStyles, FormView } from 'rewire-ui';
import Typography from '@material-ui/core/Typography';
import { Theme } from '@material-ui/core/styles';
import Grid from '../ui/Grid';
import timecardTestExpectedResultsModel from './TimecardTestExpectedResultsModel';
import timecardTestModel from './TimecardTestModel';
import { defaultFontSizes } from '../timecard/TimecardGrids';

const styles = (theme: Theme) => ({
  root: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    marginBottom: '8px',
  },
  title: {
    marginBottom: '5px',
  },
  formContainer: {
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap',
  },
  formContainerStaticFields: {
    flex: '3',
    flexWrap: 'nowrap',
  },
  hasNoDifference: {
    color: theme.palette.success.light,
  },
  hasDifference: {
    color: theme.palette.error.main,
  },
  grid: {
    '& tbody tr:hover': {
      backgroundColor: '#e0e9f0',
    },
    '& tr th div': {
      color: 'white',
      fontStyle: 'normal',
    },
    '& td.readOnly': {
      color: '#4f778a',
    },
    '& td.future': {
      fontStyle: 'italic',
      color: theme.palette.text.disabled,
    },
    '& th': {
      whiteSpace: 'pre-wrap',
      paddingTop: '3px',
      paddingBottom: '3px',
    },
  },
  formField: {
    flex: '1',
    minWidth: '115px',
  },
  testName: {
    flex: '3',
    minWidth: '200px',
    marginRight: '20px',
  },
  tags: {
    flex: '2',
    minWidth: '200px',
    marginRight: '20px',
  },
});

interface ITimecardTestExpectedResultsProps {}

type TimecardTestExpectedResultsProps = WithStyle<ReturnType<typeof styles>, ITimecardTestExpectedResultsProps>;

class TimecardTestExpectedResults extends React.PureComponent<TimecardTestExpectedResultsProps> {
  constructor(props: TimecardTestExpectedResultsProps) {
    super(props);
  }

  componentWillUnmount() {
    timecardTestExpectedResultsModel.reset();
  }

  getDifferenceClass(): string | undefined {
    const { classes } = this.props;
    const differenceValue = timecardTestExpectedResultsModel.form.field.difference.value;
    if (differenceValue > 0 || differenceValue < 0) {
      return classes.hasDifference;
    } else {
      return classes.hasNoDifference;
    }
  }

  render() {
    const { classes } = this.props;

    return (
      <div className={classes.root}>
        <Typography variant="h6" className={classes.title}>
          Timecard Expected Results
        </Typography>
        <Observe
          render={() => (
            <>
              <FormView form={timecardTestExpectedResultsModel.form} onSubmit={timecardTestModel.save}>
                <div className={classes.formContainer}>
                  <timecardTestExpectedResultsModel.form.field.name.Editor
                    className={classNames(classes.formField, classes.testName)}
                  />
                  <timecardTestExpectedResultsModel.form.field.tags.Editor
                    className={classNames(classes.formField, classes.tags)}
                  />
                  <div className={classNames(classes.formContainer, classes.formContainerStaticFields)}>
                    <timecardTestExpectedResultsModel.form.field.expectedGross.Editor className={classes.formField} />
                    <timecardTestExpectedResultsModel.form.field.calculatedGross.Editor className={classes.formField} />
                    <timecardTestExpectedResultsModel.form.field.difference.Editor
                      className={classNames(classes.formField, this.getDifferenceClass())}
                    />
                  </div>
                </div>
              </FormView>
              <Grid
                key={timecardTestExpectedResultsModel.grid.id}
                grid={timecardTestExpectedResultsModel.grid}
                gridFontSizes={defaultFontSizes}
                className={classes.grid}
              />
            </>
          )}
        />
      </div>
    );
  }
}

export default withStyles<ITimecardTestExpectedResultsProps, unknown>(styles, TimecardTestExpectedResults);
